import { MarkdownEditorConfig, MarkdownEditorPlugin } from './types';

export const defaultEditorConfig: MarkdownEditorConfig = {
  view: {
    menu: true,
    md: true,
    html: true,
  },
  canView: {
    menu: true,
    md: true,
    html: true,
    fullScreen: false,
    hideMenu: false,
  },
  imageUrl: '',
  imageAccept: '',
  linkUrl: '',
};

export const defaultPlugins: MarkdownEditorPlugin[] = [
  'header',
  'font-bold',
  'font-italic',
  'font-strikethrough',
  'list-unordered',
  'list-ordered',
  'block-quote',
  'block-wrap',
  'block-code-inline',
  'block-code-block',
  'table',
  'link',
  'clear',
  'logger',
  'mode-toggle',
  'full-screen',
];

export const markdownParserOptions = {
  html: false,
  linkify: true,
  typographer: true,
};
